<!--
  La cellule APV des tableaux repris du mail : le code, le nom, puis la ligne
  de volume et le verdict que le mail écrit sous chaque code (volumeLine,
  verdictLine de morningreport.js). Les chiffres viennent de `volume`, calculé
  une fois par harvesting2 : seule la rédaction change.

  `p` est la parcelle du ROLLUP ; null pour un APV vu du seul registre SUMAL,
  qui n'a alors ni lien, ni volume, ni verdict. `:details="false"` : le code et
  le nom seuls, comme dans le bloc des corrections SUMAL du mail.
-->
<template>
  <div>
    <router-link v-if="p" :to="parcelLink(code)" class="hv2-code">{{ code }}</router-link>
    <span v-else class="hv2-code">{{ code }}</span>
    <div class="hv2-muted">{{ name }}</div>
    <slot />
    <div v-if="details && volumeText" class="hv2-cell-line">{{ volumeText }}</div>
    <div v-if="details && p && p.verdict && p.verdict.text" class="hv2-cell-line" :class="`is-${p.verdict.tone}`">
      {{ p.verdict.text }}
    </div>
  </div>
</template>

<script>
import fmt from '../format'

// Sous ce volume, une correction SUMAL est un arrondi (MIN_M3_EN_JEU du mail).
const MIN_M3 = 0.05

export default {
  name: 'HvApvCell',
  props: {
    code: { type: String, required: true },
    label: { type: String, default: '' },
    p: { type: Object, default: null },
    details: { type: Boolean, default: true }
  },
  computed: {
    name () {
      return this.p ? fmt.parcelName(this.p) : (this.label || fmt.DASH)
    },
    volumeText () {
      const v = this.p && this.p.volume
      if (!v) return ''
      const adj = Number(v.adjust) || 0
      const total = Math.abs(adj) >= MIN_M3
        ? `${fmt.m3int(v.total)} m³ au total (contrat ${fmt.m3int(v.contract)} ${adj < 0 ? '−' : '+'} corrections SUMAL ${fmt.m3(Math.abs(adj))})`
        : `${fmt.m3int(v.total)} m³ au total`
      return `${total} · ${fmt.m3(v.remaining)} m³ restants (${fmt.int(v.pct)} %)` +
        (v.source === 'sumal' ? ' · selon SUMAL' : '')
    }
  },
  methods: {
    parcelLink: fmt.parcelLink
  }
}
</script>
